import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { DotsVerticalIcon } from '@heroicons/react/solid';
import { observer } from 'mobx-react-lite';
import classNames from '../utils/classNames';

export class MenuConfig {
  actionItems = [];

  constructor(actions, options) {
    this.actionItems = actions;
    Object.assign(this, options);
  }

  actions(row) {
    return this.actionItems.filter(
      (action) =>
        !action.validator ||
        (this.validator && this.validator(action.validator, row) === true)
    );
  }
}

function ActionMenu({ menuConfig, row = {} }) {
  const actions = menuConfig.actions(row);

  if (actions.length === 0) {
    return null;
  }

  return (
    <Menu as="div" className="inline-block text-left">
      <div>
        <Menu.Button className="rounded-full action-related flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500">
          <span className="sr-only">Open options</span>
          <DotsVerticalIcon className="h-5 w-5" aria-hidden="true" />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="origin-top-right absolute mt-2 w-34 right-6 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            {actions.map((action) => (
              <Menu.Item key={action.key}>
                {({ active }) => (
                  <button
                    className={classNames(
                      active ? 'bg-gray-200 text-gray-900' : 'text-gray-700',
                      'action-related w-full flex items-center group text-left px-4 py-2 text-sm'
                    )}
                    type="button"
                    onClick={() => menuConfig.onClick(action.onClick, row)}
                  >
                    {action.label}
                  </button>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}

export default observer(ActionMenu);
